import { render } from "./Edit.vue?vue&type=template&id=42efdfba&bindings={\"errors\":\"props\",\"tenants\":\"props\",\"roles\":\"props\",\"user\":\"props\",\"classrooms\":\"props\",\"form\":\"data\",\"update\":\"options\"}"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "42efdfba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42efdfba')) {
    api.reload('42efdfba', script)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=42efdfba&bindings={\"errors\":\"props\",\"tenants\":\"props\",\"roles\":\"props\",\"user\":\"props\",\"classrooms\":\"props\",\"form\":\"data\",\"update\":\"options\"}", () => {
    api.rerender('42efdfba', render)
  })

}

script.__file = "resources/js/Pages/Users/Edit.vue"

export default script